import React from 'react';

import * as S from './styles';

interface Props {
  defaultChecked: boolean;
  toggleSidebar():void
}

const SwitherSideBar = ({ defaultChecked, toggleSidebar }: Props) => {
  return (
    <S.SwitchWrap>
      <S.StyledSwitch defaultChecked={defaultChecked} onChange={toggleSidebar}/>
      <span>Pin-Menü</span>
    </S.SwitchWrap>
  );
};

export default SwitherSideBar;
